import React, { createContext } from "react";

export const UserInfoContext = createContext({
  userInfoData: null,
  userProfileData: null,
  userCompanyData: null,
  showNotifications: {
    showToast: false,
    toastType: "success",
    toastMessage: ""
  },
  showCreateTerms: {
    docsLength: false,
    showModal: false
  },
  openPrivacyNotice: false,
  setUserData: () => { },
  setUserProfileData: () => { },
  setUserCompanyData: () => { },
  setShowNotifications: () => { },
  setShowCreateTerms: () => { },
  setOpenPrivacyNotice: () => { },
  refetchUserProfile: () => { }
});
export const EditorInfoContext = createContext({
  editEnabled: false,
  openAddElement: false,
  geo: {},
  elements: {},
  editElement: {},
  openRemoveModal: false,
  elementsToRemove: [],
  pageNumber: 1,
  editLightBox: {},
  deletingLightbox: false,
  lightBoxList: [],
  imageElement: {},
  openLightBox: false,
  selectedPdf: '',
  showToast: {},
  tagValue: true,
  pageDimensions: {},
  isActionDisabled : false ,
  setIsActionDisabled : ()=>{},
  disableCopyText: true,
  setDisableCopyText: () => {},
  pushHistoryAction: () => {},
  undo: () => {},
  redo: () => {},
  canUndo: false,
  canRedo: false,
});
export default UserInfoContext;
